import api from './api';

const serviceService = {
  /**
   * Get all services/pricing
   * @returns {Promise} Array of services
   */
  getServices: async () => {
    const response = await api.get('/api/services');
    return response.data;
  },

  /**
   * Get a single service by ID
   * @param {string} id - Service MongoDB ID
   * @returns {Promise} Service data
   */
  getService: async (id) => {
    const response = await api.get(`/api/services/${id}`);
    return response.data;
  },

  /**
   * Update a service
   * @param {string} id - Service MongoDB ID
   * @param {Object} updateData - Fields to update
   * @returns {Promise} Updated service data
   */
  updateService: async (id, updateData) => {
    const response = await api.put(`/api/services/${id}`, updateData);
    return response.data;
  },

  /**
   * Create a new service
   * @param {Object} serviceData - Service details
   * @param {string} serviceData.categoryName - Service category name
   * @param {string} serviceData.serviceCode - Service code
   * @param {string} serviceData.pricingModel - Pricing model (PerKg, PerItem, PerPair)
   * @param {number} serviceData.pricePerKg - Price per kg (if PerKg model)
   * @param {number} serviceData.pricePerPair - Price per pair (if PerPair model)
   * @param {Array} serviceData.subcategories - Subcategories with items
   * @param {string} serviceData.standardTAT - Standard turnaround time
   * @param {string} serviceData.semiExpressTAT - Semi express TAT
   * @param {string} serviceData.expressTAT - Express TAT
   * @returns {Promise} Created service data
   */
  createService: async (serviceData) => {
    const response = await api.post('/api/services', serviceData);
    return response.data;
  },

  /**
   * Delete a service
   * @param {string} id - Service MongoDB ID
   * @returns {Promise} Deletion confirmation
   */
  deleteService: async (id) => {
    const response = await api.delete(`/api/services/${id}`);
    return response.data;
  },

  /**
   * Update service subcategory
   * @param {string} serviceId - Service MongoDB ID
   * @param {string} subcategoryId - Subcategory ID
   * @param {Object} updateData - Subcategory fields to update
   * @returns {Promise} Updated service data
   */
  updateSubcategory: async (serviceId, subcategoryId, updateData) => {
    const response = await api.put(`/api/services/${serviceId}/subcategories/${subcategoryId}`, updateData);
    return response.data;
  },

  /**
   * Add a new subcategory to a service
   * @param {string} serviceId - Service MongoDB ID
   * @param {Object} subcategoryData - Subcategory details
   * @returns {Promise} Updated service data
   */
  addSubcategory: async (serviceId, subcategoryData) => {
    const response = await api.post(`/api/services/${serviceId}/subcategories`, subcategoryData);
    return response.data;
  },

  /**
   * Remove a subcategory from a service
   * @param {string} serviceId - Service MongoDB ID
   * @param {string} subcategoryId - Subcategory ID
   * @returns {Promise} Updated service data
   */
  removeSubcategory: async (serviceId, subcategoryId) => {
    const response = await api.delete(`/api/services/${serviceId}/subcategories/${subcategoryId}`);
    return response.data;
  },
};

export default serviceService;
